import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

export interface PaletaCores {
  corPrimaria: string;
  corSecundaria: string;
  corFundo: string;
  corFundoCard: string;
  corTexto: string;
  corBotaoCta: string;
}

export interface PaletaPreset {
  nome: string;
  emoji: string;
  // Cores exibidas nos swatches
  corPrimaria: string;
  corSecundaria: string;
  corFundo: string;
  corFundoCard: string;
  corBotaoCta?: string;
  // Cores completas do tema
  corTextoPrimaria: string;
  corTextoSecundaria: string;
  corTextoTopo: string;
  corTextoFundo: string;
  corTextoBotao: string;
  corPreco: string;
  corPrecoAdicional: string;
  corTextoPrecoAdicional: string;
  corFundoDoSite: string;
  corFundoElementos: string;
  corBorda: string;
  corDestaque: string;
  corHover: string;
  corTextoRodape: string;
  corFundoRodape: string;
  corBordaRodape: string;
  corItemAtivoRodape: string;
  corBotaoMaisMenosRodape: string;
  corFundoCarrinho: string;
  corTextoCarrinho: string;
  corTexto: string;
}

// Helper para gerar paletas light (fundo claro)
function light(p: {nome: string; emoji: string; corPrimaria: string; corSecundaria: string; corFundo: string; corFundoCard: string; corBotaoCta?: string; corBorda?: string; corTextoSecundaria?: string}): PaletaPreset {
  return {
    ...p,
    corBotaoCta: p.corBotaoCta || p.corPrimaria,
    corTextoPrimaria: '#1A1A1A',
    corTextoSecundaria: p.corTextoSecundaria || '#6B7280',
    corTextoTopo: '#1A1A1A',
    corTextoFundo: '#1A1A1A',
    corTextoBotao: '#FFFFFF',
    corPreco: p.corPrimaria,
    corPrecoAdicional: p.corPrimaria,
    corTextoPrecoAdicional: '#FFFFFF',
    corFundoDoSite: p.corFundoCard,
    corFundoElementos: p.corFundoCard,
    corBorda: p.corBorda || '#E5E7EB',
    corDestaque: p.corPrimaria,
    corHover: p.corSecundaria,
    corTextoRodape: '#1A1A1A',
    corFundoRodape: p.corFundo,
    corBordaRodape: p.corBorda || '#E5E7EB',
    corItemAtivoRodape: p.corPrimaria,
    corBotaoMaisMenosRodape: '#6B7280',
    corFundoCarrinho: p.corPrimaria,
    corTextoCarrinho: '#FFFFFF',
    corTexto: '#1A1A1A'
  };
}

// Helper para gerar paletas dark (fundo escuro)
function dark(p: {nome: string; emoji: string; corPrimaria: string; corSecundaria: string; corFundo: string; corFundoCard: string; corBotaoCta?: string; corBorda?: string; corTextoSecundaria?: string}): PaletaPreset {
  return {
    ...p,
    corBotaoCta: p.corBotaoCta || p.corPrimaria,
    corTextoPrimaria: '#F3F4F6',
    corTextoSecundaria: p.corTextoSecundaria || '#9CA3AF',
    corTextoTopo: '#F3F4F6',
    corTextoFundo: '#F3F4F6',
    corTextoBotao: '#FFFFFF',
    corPreco: p.corPrimaria,
    corPrecoAdicional: p.corPrimaria,
    corTextoPrecoAdicional: '#FFFFFF',
    corFundoDoSite: p.corFundoCard,
    corFundoElementos: p.corFundoCard,
    corBorda: p.corBorda || '#374151',
    corDestaque: p.corPrimaria,
    corHover: p.corSecundaria,
    corTextoRodape: '#F3F4F6',
    corFundoRodape: p.corFundo,
    corBordaRodape: p.corBorda || '#374151',
    corItemAtivoRodape: p.corPrimaria,
    corBotaoMaisMenosRodape: '#9CA3AF',
    corFundoCarrinho: p.corPrimaria,
    corTextoCarrinho: '#FFFFFF',
    corTexto: '#F3F4F6'
  };
}

export const PALETAS_PREDEFINIDAS: PaletaPreset[] = [
  // Tema padrao do sistema
  {
    nome: 'MeuCardapio', emoji: '💜',
    corPrimaria: '#5b1da6', corSecundaria: '#b264da', corFundo: '#5b1da6', corFundoCard: '#FFFFFF',
    corBotaoCta: '#5b1da6',
    corTextoPrimaria: '#212529', corTextoSecundaria: '#6c757d',
    corTextoTopo: '#FFFFFF', corTextoFundo: '#FFFFFF',
    corTextoBotao: '#FFFFFF',
    corPreco: '#28a745', corPrecoAdicional: '#e2e3e3', corTextoPrecoAdicional: '#FFFFFF',
    corFundoDoSite: '#f7f8f8', corFundoElementos: '#FFFFFF',
    corBorda: '#e2e3e3', corDestaque: '#5b1da6', corHover: '#b264da',
    corTextoRodape: '#FFFFFF', corFundoRodape: '#5b1da6', corBordaRodape: '#4a1789',
    corItemAtivoRodape: '#FFFFFF', corBotaoMaisMenosRodape: '#FFFFFF',
    corFundoCarrinho: '#3E9920', corTextoCarrinho: '#FFFFFF',
    corTexto: '#212529'
  },
  light({ nome: 'Classico Quente', emoji: '🔥', corPrimaria: '#E84C5E', corSecundaria: '#C62828', corFundo: '#F5E6D3', corFundoCard: '#FFFFFF', corBorda: '#E8D5C0' }),
  dark({ nome: 'Hamburgueria Dark', emoji: '🍔', corPrimaria: '#F59E0B', corSecundaria: '#EF4444', corFundo: '#1A1A2E', corFundoCard: '#2D2D44', corBorda: '#3D3D5C', corTextoSecundaria: '#A1A1B5' }),
  light({ nome: 'Sorveteria Pastel', emoji: '🍦', corPrimaria: '#EC4899', corSecundaria: '#8B5CF6', corFundo: '#FFF1F2', corFundoCard: '#FFFFFF', corBorda: '#F3D1D7' }),
  light({ nome: 'Natural & Saudavel', emoji: '🥗', corPrimaria: '#059669', corSecundaria: '#10B981', corFundo: '#F0FDF4', corFundoCard: '#FFFFFF', corBorda: '#D1FAE5' }),
  light({ nome: 'Cafe & Padaria', emoji: '☕', corPrimaria: '#92400E', corSecundaria: '#B45309', corFundo: '#FEF3C7', corFundoCard: '#FFFBEB', corBorda: '#F5DEB3', corTextoSecundaria: '#78716C' }),
  light({ nome: 'Japones Minimalista', emoji: '🍣', corPrimaria: '#DC2626', corSecundaria: '#1F2937', corFundo: '#FAFAFA', corFundoCard: '#FFFFFF', corBorda: '#E5E7EB', corTextoSecundaria: '#4B5563' }),
  light({ nome: 'Italiano Classico', emoji: '🍕', corPrimaria: '#DC2626', corSecundaria: '#15803D', corFundo: '#FEF2F2', corFundoCard: '#FFFFFF', corBorda: '#FECACA' }),
  dark({ nome: 'Premium Gourmet', emoji: '✨', corPrimaria: '#D4AF37', corSecundaria: '#D4AF37', corFundo: '#0F0F0F', corFundoCard: '#1A1A1A', corBorda: '#333333', corTextoSecundaria: '#A0A0A0' }),
  light({ nome: 'Acai Tropical', emoji: '🫐', corPrimaria: '#7C3AED', corSecundaria: '#EC4899', corFundo: '#F5F3FF', corFundoCard: '#FFFFFF', corBorda: '#DDD6FE' }),
  dark({ nome: 'Churrasco na Brasa', emoji: '🥩', corPrimaria: '#FF6B35', corSecundaria: '#DC2626', corFundo: '#1C1917', corFundoCard: '#292524', corBorda: '#44403C', corTextoSecundaria: '#A8A29E' }),
  light({ nome: 'Doceria Candy', emoji: '🧁', corPrimaria: '#E11D48', corSecundaria: '#F472B6', corFundo: '#FDF2F8', corFundoCard: '#FFFFFF', corBorda: '#FBCFE8' }),
  light({ nome: 'Mexicano Fiesta', emoji: '🌮', corPrimaria: '#EA580C', corSecundaria: '#16A34A', corFundo: '#FEF9C3', corFundoCard: '#FFFFFF', corBorda: '#FDE68A' }),
  light({ nome: 'Frutos do Mar', emoji: '🦐', corPrimaria: '#0369A1', corSecundaria: '#0EA5E9', corFundo: '#F0F9FF', corFundoCard: '#FFFFFF', corBorda: '#BAE6FD' }),
  light({ nome: 'Vegano Earth', emoji: '🌱', corPrimaria: '#4D7C0F', corSecundaria: '#A16207', corFundo: '#FEFCE8', corFundoCard: '#F7FEE7', corBorda: '#D9F99D' }),
  dark({ nome: 'Boteco & Cerveja', emoji: '🍺', corPrimaria: '#CA8A04', corSecundaria: '#B91C1C', corFundo: '#1E293B', corFundoCard: '#334155', corBorda: '#475569', corTextoSecundaria: '#94A3B8' }),
  light({ nome: 'Arabe & Oriental', emoji: '🧆', corPrimaria: '#B45309', corSecundaria: '#A16207', corFundo: '#FFFBEB', corFundoCard: '#FEF3C7', corBorda: '#FDE68A', corTextoSecundaria: '#78716C' }),
  light({ nome: 'Poke Havaiano', emoji: '🥝', corPrimaria: '#0D9488', corSecundaria: '#F97316', corFundo: '#F0FDFA', corFundoCard: '#FFFFFF', corBorda: '#99F6E4' }),
  dark({ nome: 'Pizzaria Noturna', emoji: '🌙', corPrimaria: '#EF4444', corSecundaria: '#F59E0B', corFundo: '#18181B', corFundoCard: '#27272A', corBorda: '#3F3F46', corTextoSecundaria: '#A1A1AA' }),
  light({ nome: 'Lanchonete Retro', emoji: '🎸', corPrimaria: '#E11D48', corSecundaria: '#06B6D4', corFundo: '#FFF7ED', corFundoCard: '#FFFFFF', corBorda: '#FED7AA' }),
  light({ nome: 'Marmitex Caseiro', emoji: '🍱', corPrimaria: '#D97706', corSecundaria: '#059669', corFundo: '#FFFBEB', corFundoCard: '#FFFFFF', corBorda: '#FDE68A' })
];

@Component({
  selector: 'app-seletor-paletas',
  templateUrl: './seletor-paletas.component.html',
  styleUrls: ['./seletor-paletas.component.scss']
})
export class SeletorPaletasComponent implements OnInit {
  @Input() cores: PaletaCores = {
    corPrimaria: '#059669',
    corSecundaria: '#10B981',
    corFundo: '#F0FDF4',
    corFundoCard: '#FFFFFF',
    corTexto: '#1A1A1A',
    corBotaoCta: '#059669'
  };
  @Output() coresChange = new EventEmitter<PaletaCores>();
  @Output() paletaSelecionadaChange = new EventEmitter<PaletaPreset | null>();
  @Output() paletaHover = new EventEmitter<PaletaPreset | null>();

  paletasPreDefinidas = PALETAS_PREDEFINIDAS;
  paletaSelecionadaIndex = -1;
  corTextoAuto = true;

  ngOnInit() {}

  onHoverPaleta(index: number) {
    this.paletaHover.emit(this.paletasPreDefinidas[index]);
  }

  onHoverSair() {
    this.paletaHover.emit(null);
  }

  aplicarPaleta(index: number) {
    const p = this.paletasPreDefinidas[index];
    this.paletaSelecionadaIndex = index;
    this.cores = {
      ...this.cores,
      corPrimaria: p.corPrimaria,
      corSecundaria: p.corSecundaria,
      corFundo: p.corFundo,
      corFundoCard: p.corFundoCard,
      corBotaoCta: p.corBotaoCta || p.corPrimaria,
      corTexto: this.corTextoAuto ? this.getContrastText(p.corFundoCard) : this.cores.corTexto
    };
    this.paletaSelecionadaChange.emit(p);
    this.emitir();
  }

  deselecionarPaleta() {
    this.paletaSelecionadaIndex = -1;
    this.paletaSelecionadaChange.emit(null);
  }

  onCorAlterada() {
    this.deselecionarPaleta();
    this.emitir();
  }

  onCorFundoAlterada() {
    this.deselecionarPaleta();
    this.atualizarCorTextoAuto();
    this.emitir();
  }

  atualizarCorTextoAuto() {
    if (this.corTextoAuto) {
      this.cores = {
        ...this.cores,
        corTexto: this.getContrastText(this.cores.corFundoCard)
      };
    }
  }

  toggleCorTextoAuto() {
    this.corTextoAuto = !this.corTextoAuto;
    this.atualizarCorTextoAuto();
    this.emitir();
  }

  private emitir() {
    this.coresChange.emit({...this.cores});
  }

  // --- Helpers de cor ---

  getContrastText(bgHex: string): string {
    const lum = this.getRelativeLuminance(bgHex);
    return lum > 0.179 ? '#1A1A1A' : '#FFFFFF';
  }

  private getRelativeLuminance(hex: string): number {
    const rgb = this.hexToRgb(hex);
    if (!rgb) return 0;
    const [r, g, b] = [rgb.r, rgb.g, rgb.b].map(c => {
      const s = c / 255;
      return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
  }

  private hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    if (!hex) return null;
    const clean = hex.replace('#', '');
    if (clean.length !== 6) return null;
    return {
      r: parseInt(clean.substring(0, 2), 16),
      g: parseInt(clean.substring(2, 4), 16),
      b: parseInt(clean.substring(4, 6), 16)
    };
  }
}
